(() => {
  const root = document.querySelector('[data-rv-reader]');
  if (!root) return;
  const copy = JSON.parse(root.dataset.copy);
  const target = document.querySelector('.shopify-policy__body') || document.querySelector('#MainContent .rte') || document.querySelector('#MainContent article') || document.querySelector('#MainContent');
  if (!target) return;
  const clone = target.cloneNode(true);
  clone.querySelectorAll('script,style,nav,form,button,audio,video,template,[aria-hidden="true"],.rv-reader-frame').forEach(el => el.remove());
  const text = clone.textContent.replace(/\s+/g, ' ').trim();
  if (text.split(/\s+/).length < 160) return;
  root.hidden = false;
  const synth = window.speechSynthesis;
  const status = root.querySelector('[role="status"]');
  const voice = root.querySelector('select');
  const pace = root.querySelector('input');
  const panel = root.querySelector('dialog');
  const buttons = [...root.querySelectorAll('[data-rv-listen]')];
  const stop = root.querySelector('[data-rv-stop]');
  const pause = root.querySelector('[data-rv-pause]');
  let active = false, index = 0, token = 0, voices = [], selectedVoice = '', chunks = [];
  try { selectedVoice = localStorage.getItem('rv-reader-voice') || ''; pace.value = localStorage.getItem('rv-reader-pace') || '0.92'; } catch {}
  const updatePace = () => { root.querySelector('output').textContent = Number(pace.value).toFixed(2) + '×'; };
  updatePace();
  const fillVoices = () => {
    voices = synth.getVoices().filter(v => /^en\b/i.test(v.lang));
    if (!voices.length) voices = synth.getVoices();
    voice.replaceChildren();
    const option = document.createElement('option'); option.value = ''; option.textContent = copy.deviceVoice; voice.append(option);
    voices.forEach(v => { const o = document.createElement('option'); o.value = v.voiceURI; o.textContent = v.name + ' · ' + v.lang; voice.append(o); });
    voice.value = selectedVoice;
  };
  const reset = () => { token++; synth.cancel(); active = false; index = 0; buttons.forEach(b => { b.textContent = copy.listen; b.setAttribute('aria-pressed', 'false'); }); pause.textContent = copy.pause; status.textContent = copy.stopped; };
  if (!synth || !window.SpeechSynthesisUtterance) {
    buttons.forEach(b => b.addEventListener('click', () => { panel.showModal(); status.textContent = copy.unsupported; }));
    root.querySelectorAll('select,input,[data-rv-pause],[data-rv-stop]').forEach(el => el.disabled = true);
  } else {
    fillVoices(); synth.addEventListener('voiceschanged', fillVoices);
    const sentences = text.match(/[^.!?]+[.!?]+(?:\s|$)|[^.!?]+$/g) || [text];
    sentences.forEach(sentence => { let value = sentence.trim(); while (value.length > 240) { let at = value.lastIndexOf(' ', 240); if (at < 1) at = 240; chunks.push(value.slice(0, at)); value = value.slice(at).trim(); } if (value) chunks.push(value); });
    const speak = session => {
      if (!active || session !== token) return;
      if (index >= chunks.length) { reset(); status.textContent = copy.finished; return; }
      const utterance = new SpeechSynthesisUtterance(chunks[index]);
      const picked = voices.find(v => v.voiceURI === voice.value); if (picked) utterance.voice = picked;
      utterance.lang = picked?.lang || document.documentElement.lang || 'en-US'; utterance.rate = Number(pace.value); utterance.pitch = 1;
      utterance.onend = () => { if (session === token && active) { index++; speak(session); } };
      utterance.onerror = event => { if (event.error !== 'canceled' && event.error !== 'interrupted') { reset(); status.textContent = copy.error; } };
      synth.speak(utterance);
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      if (!panel.open) panel.showModal();
      if (active) { status.textContent = copy.playing; return; }
      synth.cancel(); document.querySelectorAll('audio,video').forEach(el => el.pause()); active = true; index = 0; token++;
      buttons.forEach(b => { b.textContent = copy.listening; b.setAttribute('aria-pressed', 'true'); }); status.textContent = copy.playing; speak(token);
    }));
    pause.addEventListener('click', () => { if (!active) return; if (synth.paused) { synth.resume(); pause.textContent = copy.pause; status.textContent = copy.playing; } else { synth.pause(); pause.textContent = copy.resume; status.textContent = copy.paused; } });
    stop.addEventListener('click', reset);
    voice.addEventListener('change', () => { selectedVoice = voice.value; try { localStorage.setItem('rv-reader-voice', selectedVoice); } catch {} if (active) reset(); });
    pace.addEventListener('input', () => { updatePace(); try { localStorage.setItem('rv-reader-pace', pace.value); } catch {} });
    window.addEventListener('pagehide', reset);
    document.addEventListener('play', event => { if (event.target instanceof HTMLMediaElement && active) reset(); }, true);
  }
  const frame = document.createElement('div'); frame.className = 'rv-reader-frame';
  target.classList.add('rv-readable'); target.prepend(frame);
  buttons.forEach(button => frame.append(button));
  root.querySelector('[data-rv-close]').addEventListener('click', () => panel.close());
})();
